import React, { FC, ReactNode } from 'react'
import { ButtonProps } from '@mui/material/Button'
import { ErrorBoundary } from '../'
import ButtonWIthCustomCSS from './custom-button-style'

interface IProps extends ButtonProps {
  children: string | ReactNode
}

const CustomButton: FC<IProps> = ({ variant, children, ...rest }) => (
  <ErrorBoundary>
    <ButtonWIthCustomCSS
      color="primary"
      variant={variant || 'contained'}
      {...rest}
    >
      {children}
    </ButtonWIthCustomCSS>
  </ErrorBoundary>
)

export default CustomButton
